// @flow
import React from 'react';
import { View } from 'react-native';

// Why this works now (and why the old Navbar didn't):
// The other sticky bars (HistoryTabs / TabNav) use a plain react-native <View>
// with a style OBJECT of valid RN style keys, and react-native-web maps
// `position: 'sticky'` onto real CSS for us. The old Navbar instead used
// `styled(View)` from 'styled-components/native' with web-CSS *text*
// (background / border-bottom-width / overflow: none), which the native styled
// build silently drops. So the fix is simply to use a plain <View> with a valid
// RN style object - no <div> and no styled-components required.
//
// Caller (Root) can still override via props.style; it is merged LAST.
const baseStyle = {
	flexDirection:      'row',
	justifyContent:     'space-between',
	alignItems:         'stretch',
	flexBasis:          '2.7em',

	padding:            '0.5rem',
	overflow:           'hidden',            // RN-valid value ("none" is not)

	backgroundColor:    '#fff',             // RN key, not web "background"
	borderBottomWidth:  0.5,                // RN keys, not web "border-bottom-*"
	borderBottomColor:  'rgb(220,220,220)',

	position:           'sticky',
	top:                0,
	zIndex:             100,
};

const Navbar = ({ style, children, ...rest }) => (
	<View style={{ ...baseStyle, ...style }} {...rest}>{children}</View>
);

export default Navbar;
